import React, { useState, useEffect } from 'react';

// Import functions from components.js
import { isBritishCitizen, getParliamentaryTerms, hasCurrentTerm } from './components';

export const StartPetitionSection = ({ user, setCurrentPage }) => {
  const [canCreateToday, setCanCreateToday] = useState(true);
  const [parliamentInSession, setParliamentInSession] = useState(false); // Default to false
  const [termsLoading, setTermsLoading] = useState(true);

  useEffect(() => {
    if (user) {
      const today = new Date().toDateString();
      const petitionCountKey = `petition_count_${user.id}_${today}`;
      const todayCount = parseInt(localStorage.getItem(petitionCountKey) || '0', 10);
      setCanCreateToday(todayCount < 3); // Allow up to 3 petitions per day
    }
  }, [user]);

  // Load parliamentary terms to check if Parliament is in session
  useEffect(() => {
    const loadTerms = async () => {
      setTermsLoading(true);
      try {
        const fetchedTerms = await getParliamentaryTerms();
        const inSession = hasCurrentTerm(fetchedTerms);
        setParliamentInSession(inSession);
      } catch (error) {
        console.error('Error loading terms:', error);
        setParliamentInSession(false);
      } finally {
        setTermsLoading(false);
      }
    };

    loadTerms();
  }, []);

  return (
    <div className="bg-gray-50 py-12">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Start your own petition</h2>
        
        {!parliamentInSession && (
          <div className="max-w-md mx-auto mb-4 p-4 bg-red-100 border border-red-300 rounded-lg">
            <p className="text-red-700 text-sm">
              <strong>Parliament Not In Session:</strong> New petitions cannot be created at this time.
            </p>
          </div>
        )}
        
        {!canCreateToday && user && parliamentInSession && (
          <div className="max-w-md mx-auto mb-4 p-3 bg-orange-100 border border-orange-300 rounded-lg">
            <p className="text-orange-700 text-sm">
              <strong>Rate Limit:</strong> You can create 3 petitions per day
            </p>
          </div>
        )}

        <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
          {parliamentInSession 
            ? "When you create a petition, you'll be the first to automatically sign it."
            : "Petitions can only be created when Parliament is in session. Please check back when the next parliamentary term begins."
          }
        </p>
        
        {user ? (
          isBritishCitizen(user) ? (
            <button
              onClick={() => setCurrentPage('create-petition')}
              disabled={termsLoading || !canCreateToday || !parliamentInSession}
              className={`px-8 py-4 rounded-lg font-medium text-lg transition-colors ${
                (termsLoading || !canCreateToday || !parliamentInSession)
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-emerald-600 text-white hover:bg-emerald-700'
              }`}
            >
              {termsLoading ? 'Checking Parliament Status...' : 
               !parliamentInSession ? 'Parliament Not In Session' : 
               'Start a petition'}
            </button>
          ) : (
            <div className="max-w-md mx-auto">
              <p className="text-gray-600 mb-4">
                You need to be a British Citizen to create petitions.
              </p>
              <button
                disabled
                className="bg-gray-300 text-gray-500 px-8 py-4 rounded-lg font-medium text-lg cursor-not-allowed"
              >
                Insufficient Permissions
              </button>
            </div>
          )
        ) : (
          <div className="max-w-md mx-auto">
            <p className="text-gray-600 mb-4">Connect your ROBLOX account to start creating petitions</p>
            <button
              disabled
              className="bg-gray-300 text-gray-500 px-8 py-4 rounded-lg font-medium text-lg cursor-not-allowed"
            >
              Connect Account to Start
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Footer Component
